import { useCallback, useEffect, useMemo, useState } from 'react'
import { fetchListingsByPerson } from '../api/peopleProducts'
import type { Listing } from '../api/store'

export function usePersonProducts(publicId?: string) {
  const [items, setItems] = useState<Listing[]>([])
  const [cursor, setCursor] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const canLoadMore = useMemo(() => Boolean(cursor), [cursor])

  const load = useCallback(
    async (reset = false) => {
      if (!publicId || loading) return
      setLoading(true)
      setError(null)
      try {
        const res = await fetchListingsByPerson(publicId, reset ? null : cursor)
        setCursor(res.next_cursor)
        setItems((prev) => (reset ? res.items : [...prev, ...res.items]))
      } catch (e: any) {
        setError(e?.message || 'Failed to load products')
      } finally {
        setLoading(false)
      }
    },
    [publicId, cursor, loading]
  )

  useEffect(() => {
    setItems([])
    setCursor(null)
    if (publicId) void load(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publicId])

  return { items, loading, error, canLoadMore, loadMore: () => load(false), refresh: () => load(true) }
}

